<div class="bg-color-base-2500 h-100vh">
    <grid-row *ngIf="RequestLetter==false" class="justify-content-center align-content-center h-100">
        <grid-col col="4" mobile="11"  ipad="8" class="text-align-center">
                <ng-icon iconClass="icon-success-100px" width="100" height="100"></ng-icon>

            <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3" >
                {{"YournewcardPIN" | translate}}
            </div>
            

            <grid-row class="justify-content-center">
                <grid-col col="10" mobile="11">
                    <grid-row class="mt-30">
                        <grid-col col="12">
                            <button class="btn-dft-border" (click)="Dashboard()">
                                {{ "Done" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
        </grid-col>

    </grid-row>

</div>
